import React from "react";
import { Checkbox, TableCell, TableRow } from "../..";
import { DataTableColumn, MenuAction } from "../DataTable.types";
import MoreMenu from "./MoreMenu";
import { useStyles } from "./DataRow.styles";

interface DataRowProps<T extends { [key: string]: any }> {
  onToggleSelect?: (id: string) => void;
  idKey: keyof T;
  row: T;
  columns: DataTableColumn<T>[];
  checked: boolean;
  enableEdit?: boolean;
  renderBodyWrapper: (content: React.ReactNode) => React.ReactNode;
  moreActions?: MenuAction<T>[];
  checkedDisabled?: boolean;
  sidePadding?: number;
  hideCheckbox?: boolean;
}

function DataRow<T extends { [key: string]: any }>(props: DataRowProps<T>) {
  const {
    row,
    columns,
    checked,
    enableEdit,
    renderBodyWrapper,
    idKey,
    onToggleSelect,
    moreActions,
    checkedDisabled,
    sidePadding,
    hideCheckbox = false,
  } = props;

  const classes = useStyles();

  const id = row[idKey] as unknown as string;

  return (
    <TableRow>
      {!hideCheckbox && (
        <TableCell className={classes.checkboxCell}>
          <Checkbox
            color="primary"
            onChange={() => onToggleSelect?.(id)}
            checked={checked}
            disabled={!enableEdit || checkedDisabled}
          />
        </TableCell>
      )}
      {columns.map((column, index) => (
        <TableCell key={index} {...column.cellProps}>
          {column.useBodyWrapper === false
            ? column.renderBody(row)
            : renderBodyWrapper(column.renderBody(row))}
        </TableCell>
      ))}
      {enableEdit && !!moreActions?.length && (
        <MoreMenu row={row} actions={moreActions} sidePadding={sidePadding} />
      )}
    </TableRow>
  );
}

export default React.memo(DataRow) as unknown as typeof DataRow;
